// extracted by mini-css-extract-plugin
export default {"text":"PartnerGameAdd_text__XxZBL","row":"PartnerGameAdd_row__Y52Nx","btnCreate":"PartnerGameAdd_btnCreate__1jbiA","linkNewProduct":"PartnerGameAdd_linkNewProduct__XoWRB"};